// Limit to email safe fonts only
// See spike: https://dialexa.atlassian.net/browse/ISE-946
export const enum EmailFontOptions {
  Helvetica = '"Helvetica", sans-serif',
  LibreBaskerville = '"Libre Baskerville", sans-serif',
  TimesNewRoman = '"Times New Roman", serif'
}
